"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TokenRoutes = require("./TokenRoutes");
var _constants = require("./constants");
var _AuthCookies = require("./internals/AuthCookies");
var _TokenFetcher = require("./internals/TokenFetcher");
var _logger = require("./logger");
var _SessionTokenStorage = require("./storage/SessionTokenStorage");
const logger = _logger.mainLogger.createChild('TokenClient');
class TokenClient {
  constructor(options) {
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "storage", void 0);
    (0, _defineProperty2.default)(this, "tokenConfiguration", void 0);
    (0, _defineProperty2.default)(this, "timeout", null);
    (0, _defineProperty2.default)(this, "isTimeoutSet", false);
    /**
     * Stored token in memory, access value from this.getTokenData()
     */
    (0, _defineProperty2.default)(this, "_tokenData", null);
    // This is for backward compatibility
    // TODO: This is kind of sketchy - lets TokenClientOptions.url be a enum instead of plain string in next major release
    const providedUrlIsValid = Object.values(_TokenRoutes.TokenRoutes).includes(options.url);
    if (!providedUrlIsValid) {
      logger.warn(`Provided options.url ${options.url} is not valid and will be deprecated in the next release of @ori/auth`);
      // eslint-disable-next-line no-param-reassign -- okay for this case
      options.url = _TokenRoutes.TokenRoutes.PUBLIC_ACCESS;
    }
    this.options = options;
    this.tokenConfiguration = providedUrlIsValid ? _constants.tokenConfigurationForTokenRoutes[this.options.url] : _constants.tokenConfigurationForTokenRoutes[_TokenRoutes.TokenRoutes.PUBLIC_ACCESS];

    // TODO: in the future we probably will not support adding custom storage
    this.storage = this.options.storage ?? new _SessionTokenStorage.SessionTokenStorage(this.tokenConfiguration.sessionStorageKey);
  }
  bindTokenUpdated(handler) {
    document.addEventListener(this.tokenConfiguration.eventName, handler);
    return this;
  }
  unbindTokenUpdated(handler) {
    document.removeEventListener(this.tokenConfiguration.eventName, handler);
    return this;
  }
  async getToken() {
    const isTokenRefreshed = await this.refreshToken();
    return isTokenRefreshed ? this.getTokenData() : null;
  }
  async refreshToken() {
    // Get real stored token data, lifetime of token is managed there (it won't return token even if it's expired)
    const storageTokenData = this.storage.getToken();
    if (!storageTokenData) {
      // Clearing token data inside is necessary since storage returned empty and this instance should reflect that
      this.clearTokenData();
      let newTokenData = null;

      // If this token client is configured for user token and
      // user is not logged in then there is no need to fetch at all
      if (this.storage.isForUserToken() && !_AuthCookies.AuthCookies.hasAuthorizedUserValue()) {
        throw new Error('User is not logged so we cannot retrieve user token, skipping');
      }
      try {
        newTokenData = await this.requestToken();
      } catch (error) {
        throw new Error(`Refreshing token failed, requesting token was not successful: ${error.message}`);
      }
      if (newTokenData) {
        this.setTokenData(newTokenData);
      } else {
        throw new Error('Could not obtain user or public token at all');
      }
    }
    this.setRefreshTimeout(this.getTokenData());
    return true;
  }
  async requestToken() {
    try {
      return await _TokenFetcher.TokenFetcher.fetch({
        ...this.options.requestOptions,
        url: this.options.url
      });
    } catch (error) {
      throw new Error(`Token request has failed: ${error}`);
    }
  }
  setRefreshTimeout(tokenData) {
    if (this.isTimeoutSet || !tokenData) {
      return;
    }
    this.isTimeoutSet = true;
    if (this.timeout !== null) {
      window.clearTimeout(this.timeout);
    }
    this.timeout = window.setTimeout(() => {
      this.isTimeoutSet = false;
      void this.refreshToken();
    }, this.getTokenRefreshTime(tokenData));
  }

  /**
   * Dispatches custom event with current token data on this instance, if no token data are present then its skipped
   */
  dispatchTokenUpdated() {
    const tokenData = this.getTokenData();
    if (!tokenData) {
      return;
    }
    const event = new CustomEvent(this.tokenConfiguration.eventName, {
      detail: {
        tokenData
      }
    });
    document.dispatchEvent(event);
  }

  /**
   * Loads token onto instance
   */
  getTokenData() {
    this._tokenData ??= this.storage.getToken();
    return this._tokenData;
  }

  /**
   * Clears token from instance and storage
   */
  clearTokenData() {
    this._tokenData = null;
    this.storage.token.remove();
    return this;
  }

  /**
   * Sets new token data on instance and saves it to storage
   */
  setTokenData(tokenData) {
    this._tokenData = tokenData;
    // set token and add User id if not exist in data
    this.storage.setToken(tokenData);
    this.dispatchTokenUpdated();
    return this;
  }
  getTokenRefreshTime(tokenData) {
    const expirationDate = Date.parse(tokenData.ExpirationDate);
    const currentDate = Date.now();
    let timeToRefresh = expirationDate - currentDate;
    if (timeToRefresh <= TokenClient.TOKEN_REQUEST_INTERVAL) {
      timeToRefresh = 0;
    }
    return timeToRefresh;
  }
}
exports.TokenClient = TokenClient;
(0, _defineProperty2.default)(TokenClient, "TOKEN_REQUEST_INTERVAL", 30000);
//# sourceMappingURL=TokenClient.js.map